export default __webpack_public_path__ + "static/media/hoa.a010cf83.svg";